import Vue from 'vue'

const state = {
  unlimitedBooks: [],
};

const mutations = {
  'SET_UNLIMITED_BOOKS' (state, books) {
    state.unlimitedBooks = books;
  },
};

const actions = {
  getUnlimitedRanking: ({commit}, info) => {
    return Vue.http.get('books/all/unlimited')
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.error) {
          return 'error';
        }
        commit('SET_UNLIMITED_BOOKS', data.books);
        return data;
      })
      .catch(() => {
        return 'error';
      });
  },
};

const getters = {
  unlimitedBooks: state => {
    return state.unlimitedBooks;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/unlimited.js